<!--
SPDX-FileCopyrightText: syuilo and misskey-project
SPDX-License-Identifier: AGPL-3.0-only
-->

<template>
<slot></slot>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" module>
</style>
